import styled from '@emotion/styled';
import { useEffect } from 'react';

const Card = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  padding: 100px 24px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: var(--font-work-sans, 'Work Sans'), sans-serif;
`;

const ErrorImage = styled.img`
  width: 323px;
  height: auto;
  margin: 0 0 24px;
`;

const Heading = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #28293c;
`;

const Body = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: #5d5d5d;
`;

export function ErrorFallback({
  error,
  onMount,
  onUnmount,
}: {
  error: Error;
  onMount?: () => void;
  onUnmount?: () => void;
}) {
  console.warn(error.message);

  useEffect(() => {
    onMount?.();
    return () => onUnmount?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card>
      <ErrorImage
        src="https://res.cloudinary.com/updater-marketing/image/upload/f_auto,q_auto/v1/404%20error/Updater_Toolbox_SVG"
        alt="vector drawing of an open toolbox"
      />
      <Heading>
        Oops! Looks like we&apos;re having some technical difficulties
      </Heading>
      <Body>
        We&apos;re putting up walls and painting them with fresh code and such.
        We&apos;ll get this cleaned up in no time.
      </Body>
    </Card>
  );
}
